import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, path = "" }) => {
  const fullTitle = title
    ? `${title} | Aima Women's Health`
    : "Aima Women's Health - Holistic Hormone Health, UK";
  const desc =
    description ||
    "Functional and circadian hormone health for women. PCOS, perimenopause, thyroid, PMS, fertility awareness.";
  const url = `https://aimawomenshealth.com${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
};
